<template>
  <el-input
    v-bind="$attrs"
    class="f360-input"
    v-model="vcModelValue"
    :class="{ 'f360-input--error': error }"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps<{
  error?: boolean;
  modelValue: string;
}>();

const vcModelValue = ref("");

defineExpose({
  vcModelValue
});
</script>

<style lang="scss">
@use "element-plus/theme-chalk/el-input.css";

.f360-input {
  .el-input {
    &__inner {
      font-size: 12px;
      line-height: 16px;
    }
  }

  &--error {
    .el-input {
      &__wrapper {
        box-shadow: none;
        border: 1px solid #ed1517;

        &:hover {
          background-color: #fff1f1;
        }
      }
    }
  }
}
</style>
